import React, { useState } from 'react';
import Navbar from "./Navbar";
import Footer from "./Footer";

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // 这里可以添加表单提交逻辑
        console.log('Form submitted:', formData);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    return (
        <>
            <Navbar />

            <div className="min-h-screen bg-white py-24">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h1 className="text-4xl font-extrabold bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent mb-8">
                        Contact Us
                    </h1>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                        {/* Contact Information */}
                        <div>
                            <div className="prose prose-blue max-w-none">
                                <p className="text-lg text-gray-600 mb-8">
                                    We'd love to hear from you! Whether you have a question about our service, need technical support,
                                    or want to explore business opportunities, our team is here to help.
                                </p>

                                <div className="space-y-6">
                                    <div>
                                        <h3 className="text-lg font-semibold text-gray-900">Email</h3>
                                        <p className="text-gray-600">
                                            <a href="mailto:support@removebackground.online" className="text-blue-600 hover:text-blue-500">
                                                support@removebackground.online
                                            </a>
                                        </p>
                                    </div>

                                    <div>
                                        <h3 className="text-lg font-semibold text-gray-900">Business Inquiries</h3>
                                        <p className="text-gray-600">
                                            <a href="mailto:business@removebackground.online" className="text-blue-600 hover:text-blue-500">
                                                business@removebackground.online
                                            </a>
                                        </p>
                                    </div>

                                    <div>
                                        <h3 className="text-lg font-semibold text-gray-900">Response Time</h3>
                                        <p className="text-gray-600">
                                            We typically respond within 24-48 hours during business days.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Contact Form */}
                        <img src='https://images.unsplash.com/photo-1556761175-b413da4baf72?ixlib=rb-1.2.1&auto=format&fit=crop&w=1567&q=80'></img>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Contact;